module.exports = "/_next/static/images/f6fafe43ece0a37783fe86ef01c439df-website-thumb-large.jpg";